import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

import { useAppTheme } from "../../theme/useAppTheme";
import useCurrency from "../../hooks/useCurrency";

const PaymentStatusScreen = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  console.log("state", state);

  const themeColors = useAppTheme();

  const { symbol } = useCurrency();

  const isSuccess = state?.isSuccess || false;
  const orderId = state?.orderId || "N/A";
  const amount = state?.amount || 0;
  const invoiceUrl = state?.invoiceUrl || "";
  const metalNameRaw = state?.metalName;
  const metalPurityRaw = state?.metalPurity;
  const karat = state?.karat;

  // fallback name (your existing logic)
  const metalName = metalNameRaw || "Product";
  const metalPurity = metalPurityRaw || "";

  let displayMetal = metalName;
  const isInvalidPurity =
    !metalNameRaw ||
    metalPurityRaw === "undefined undefined" ||
    metalPurityRaw === undefined ||
    metalPurityRaw === null;
  if (!isInvalidPurity) {
    if (karat) {
      displayMetal = `${metalName}-${karat}k-${metalPurity}`;
    } else if (typeof metalPurity === "string" && metalPurity.includes(" ")) {
      const [k, p] = metalPurity.split(" ");
      displayMetal = `${metalName}-${k}k-${p}`;
    } else if (metalPurity) {
      displayMetal = `${metalName}-${metalPurity}`;
    }
  }

  const now = new Date();
  const month = now.toLocaleString("en-US", { month: "short" });
  const day = now.getDate();
  const hours = now.getHours();
  const minutes = now.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  };

  const formattedDateTime = `${month} ${day}${getOrdinal(day)} ${formattedHours}:${minutes}${ampm}`;

  const metalColor =
    metalName === "Gold"
      ? "linear-gradient(135deg, #FFD700, #DAA520)"
      : metalName === "Silver"
        ? "linear-gradient(135deg, #C0C0C0, #E0E0E0)"
        : "linear-gradient(135deg, #B0BEC5, #ECEFF1)";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: themeColors.scaffoldGradientColors,
      }}
    >
      <Card
        sx={{
          width: "50vw",
          borderRadius: "25px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
          background: themeColors.bigContainer,
          border: `1px solid ${themeColors.scaffold}`,
          color: themeColors.text,
          p: 3,
        }}
      >
        <CardContent>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            {isSuccess ? (
              <CheckCircleOutlineIcon sx={{ fontSize: 80, color: "#4CAF50" }} />
            ) : (
              <CancelOutlinedIcon sx={{ fontSize: 80, color: "#F44336" }} />
            )}
          </Box>

          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              color: isSuccess ? "#4CAF50" : "#F44336",
              mb: 1,
            }}
          >
            {isSuccess ? "Payment Successful" : "Payment Failed"}
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              mb: 3,
            }}
          >
            {isSuccess
              ? state?.successMessage ||
                "Your payment successful. The gold will be credited to your holdings."
              : "Your payment could not be completed. Please try again."}
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Box
            sx={{
              background: metalColor,
              borderRadius: "15px",
              textAlign: "center",
              p: 2,
              mb: 3,
              boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#fff", letterSpacing: 0.5 }}
            >
              {displayMetal}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography sx={{ fontWeight: "bold" }}>
              Reference Number
            </Typography>
            <Typography>{orderId}</Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
            <Typography sx={{ fontWeight: "bold" }}>Date & Time</Typography>
            <Typography>{formattedDateTime}</Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
            <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
              Total Amount
            </Typography>
            <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
              {symbol}{amount}
            </Typography>
          </Box>

          {isSuccess && invoiceUrl && (
            <Button
              fullWidth
              variant="contained"
              sx={{
                background: themeColors.primary,
                color: themeColors.text,
                borderRadius: "25px",
                py: 1.2,
                fontWeight: "bold",
                "&:hover": {
                  background: themeColors.svgColor,
                },
                border: `1px solid ${themeColors.scaffold}`,
              }}
              onClick={() => window.open(invoiceUrl, "_blank")}
            >
              Download Invoice
            </Button>
          )}

          <Button
            fullWidth
            sx={{
              mt: 2,
              borderRadius: "25px",
              fontWeight: "bold",
              background: themeColors.primary,
              color: themeColors.text,
              "&:hover": {
                background: themeColors.svgColor,
              },
              border: `1px solid ${themeColors.scaffold}`,
            }}
            onClick={() => navigate("/Dashboard")}
          >
            Back to Home
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentStatusScreen;
